// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.storage.user.claim.RentalManagerUserClaimType

export enum RentalManagerUserClaimType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export const RentalManagerUserClaimType_values = [
  RentalManagerUserClaimType.EMAIL,
  RentalManagerUserClaimType.PHONE,
] as const;
